import React, { FC, useEffect } from 'react';
import clsx from 'clsx';
import { useVisitorSpyOptinState } from 'shared/hooks';
import { Button } from 'shared/components/Button';
import { sendResetSpyOptin } from 'shared/store/realtime-slice';
import { useAppDispatch } from 'shared/store';
import './style.less';

export const SpyOptinOverlay: FC = () => {
  const dispatch = useAppDispatch();
  const s = useVisitorSpyOptinState();
  const [isReasking, setIsReasking] = React.useState(false);
  const [isShowReask, setIsShowReask] = React.useState(true);

  const handleReAsk: React.MouseEventHandler<HTMLElement> = async evt => {
    evt.stopPropagation();
    setIsReasking(true);
    await dispatch(sendResetSpyOptin());
    setIsReasking(false);
    setIsShowReask(false);
  };

  useEffect(
    function delayShowReaskEffect() {
      const to = setTimeout(() => setIsShowReask(true), 5000);
      return () => clearTimeout(to);
    },
    [isShowReask],
  );

  if (!s.isShowOverlay || !s.visitor?.sid) {
    return null;
  }

  return (
    <div className={clsx('SpyOptinOverlay')}>
      <div>
        <div>
          <ViewIcon />
        </div>
        <b>Waiting for user's consent</b>
        <p>Screen viewing is blocked, waiting for the user's consent to turn it on.</p>
        <Button
          type="ghost"
          loading={isReasking}
          disabled={!isShowReask}
          onClick={handleReAsk}
        >
          {isShowReask ? <>Re-ask for consent</> : <>✓ Re-asked</>}
        </Button>
      </div>
    </div>
  );
};

const ViewIcon = () => (
  <svg viewBox="0 0 28 26" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.90691 18.3333L8.24024 23.6667M24.2269 9V4.23734C24.2269 2.43734 22.7736 0.997337 20.9869 1H4.21357C2.41357 1 0.973575 2.44 0.986908 4.23734V15.0907C0.986908 16.8773 2.42691 18.3173 4.22424 18.3173H14.3176M6.24024 23.6667H11.6669M25.6669 25H17.0002C16.6269 25 16.3336 24.6933 16.3336 24.3333V23.7867C16.3336 22.24 17.5736 20.9867 19.1202 20.9867H23.5336C25.0669 20.9867 26.3202 22.2267 26.3202 23.7733V24.3067C26.3202 24.6667 26.0136 24.9733 25.6536 24.9733L25.6669 25ZM21.3336 17.6667C19.8536 17.6533 18.6669 16.4667 18.6669 14.9867C18.6669 13.5067 19.8536 12.32 21.3336 12.32C22.8002 12.32 23.9869 13.5067 23.9869 14.9867C23.9736 16.4533 22.7869 17.64 21.3202 17.64L21.3336 17.6667Z"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </svg>
);
